const CONFIG = {
  SUB_DOMAIN_NAME: "xselapp",
  DOMAIN_URL:"https://xselapp.training.com/",
  IOS_PACKAGE_NAME: "com.niit.xceed",
  ANDROID_PACKAGE_NAME: "com.niit.xceed",
  API_URL: "https://xselappadmin.training.com/",
  ROLEPLAY_SOCKET_URL: "https://realtorsuccesslearning-prod-videosocket.niit-mts.com/",
  IN_BUCKET_URL: "https://lt-in.s3.amazonaws.com/prod",
  OUT_BUCKET_URL: "https://cdn.niit-mts.com",
  SCORM_URL: "https://xselappadmin.training.com/public/scorm_player",
  SCORM_URL_BROKER:  "https://xselappadministrator.training.com/public/scorm_player.php",
  //WOO commerse related variable
  API_URL_BROKER: "https://xselappecom.training.com",
  API_URL_BROKER_ADMIN:  "https://xselappadministrator.training.com",
  SHOW_LIVE: false,
  ROLEPLAY_PARTICIPANT_GUIDE:  "https://cdn.training.com/xsel/resource/Roleplay_help-Participant_guide.pdf",
  ROLEPLAY_COACH_GUIDE:  "https://cdn.training.com/xsel/resource/Roleplay_help-Coach_guide.pdf",
  API_URL_REAL_BROKER: "https://xselappadministrator.training.com/",
  KEY: {
    // STRIPE_KEY: 'pk_test_51L1VejSAhcjWU0OJxqVqHvGHAro5uMh6eUZGjClM2ak7iVAqktXc4k0F59RLYF7KbsKx6jYqigpjgJG9wdr4SgDz001WV3GMxC',
    STRIPE_KEY: "pk_live_51M4ri2G1MnCffT1s1StLmIkl2AGZQViOdsEpjCFgwSZnG3CrooY7ftUYtZjzjCTTkZvKoXG0OuuNF2KfrfUJ8rzB00LSGidz52",
    MOBILE_ACCESS_KEY: "xsel_1SIEL3islIELABEI",
  },
  STRIPE_RETURN_URL:  "https://xselapp.training.com",
  COLOR_ELEMENT_1: "#7F56D9",
  COLOR_ELEMENT_2: "#53389E",

  NEXT_RELEASE: false,
  C21_BROKER_ID: 3,

  C21_COMPANY_ID:  31,  


  PAGINATION_PAGE_SIZE: 12,
  THRESHOLD_FOR_HOST: 1,
  THRESHOLD_FOR_PARTICIPANT: 30,
  THRESHOLD_FOR_LIVE_BUTTON_ACTIVE: 900, // 15 mins * 60
  DEFAULT_AVATAR: "/images/avatar.svg",
  ENV: window.location.origin.includes("stg")
    ? "STG"
    : window.location.origin.includes("doceree")
    ? "PROD"
    : window.location.origin.includes("citizen")
    ? "UAT"
    : (window.location.origin.includes("uat") || window.location.origin.includes("sandbox") || window.location.origin.includes("demo"))
    ? "UAT"
    : window.location.origin.includes("local") ||
      window.location.origin.includes("192.168") ||
      window.location.origin.includes("dev")
    ? "DEV"
    : "PROD",
    

    SECRET_KEY:  "VYRMDiXZRpg5ZpM3",

  INITIAL_PRODUCT_CARD_DATA: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
  ],
  INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
      show4: true,
    },
  ],

  INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_VIDEOS: [
    {
      tagsArray: [1, 2],
      isLoading: true,
    },
  ],
  INITIAL_PRODUCT_CARD_DATA_FOR_POPULAR_COURSES: [
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
    {
      tagsArray: [1, 2, 3, 4],
      isLoading: true,
    },
  ],

  INITIAL_PRODUCT_CARD_DATA_FOR_ORDERS: [
    {
      tagsArray: [],
      showHeader: true,
      showBody: false,
      showFooter: false,
      showProgresss: false,
      isLoading: true,
    },
  ],

  STARTER_TEXT: "Your starter subscription is free and includes a set of 5 foundational courses from Xsel, 5 videos from Leader’s Edge Training, 2 videos from Mary-Anne Gillespie - Red Apple Coaching, 15 videos from REMARKETER and a monthly webinar and newsletter from leading experts.",
  PRO_TEXT: "Your pro subscription costs $12.99 per month and includes a set of 10 foundational courses from Xsel, 15 videos from Leader’s Edge Training, 2 role plays, 2 videos from Mary-Anne Gillespie - Red Apple Coaching, 15 videos from REMARKETER and 2 monthly webinars and newsletters from leading experts.",
  PREMIUM_TEXT: "Your premium subscription costs $19.99 per month and includes a set of 22 foundational courses from Xsel, 54 videos from Leader’s Edge Training, 4 videos from A Lady’s Touch Inc., a course from Tom Storey, 4 role plays, 2 videos from Mary-Anne Gillespie - Red Apple Coaching, 15 videos from REMARKETER and access to all monthly webinars and newsletters from leading experts.",
  OFFER_START_TIME:"2024-12-10T00:00:00",
  OFFER_END_TIME:"2024-12-12T11:59:59",

};

export default CONFIG;
